import ModelService from 'src/lib/api/model.service';

export async function searchModels({ commit }, { params }) {
  const response = await ModelService.searchModels({ params });
  if (response.status === 200) {
    commit('updateModels', { models: response.data.data });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}

export async function getModel({ commit }, { id }) {
  const response = await ModelService.getModel({ id });
  if (response.status === 200) {
    commit('updateCurrentModel', { model: response.data });
  }
}

export async function updateModel(context, { id, model }) {
  await ModelService.updateModel({ id, model });
}
